import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './styles.less';

export const HoyaLogo = ( props ) => {
    // Construct the classes to use for the root component.
    const classes = classnames(
        'hoya-logo',
        { [ props.className ]: Boolean( props.className ) },
    );

    return (
        <img
            className={ classes }
            src="/images/hoya-logo@2x.png"
            alt=""
        >
            { props.children }
        </img>
    );
};

HoyaLogo.defaultProps = {
    // ...
};

HoyaLogo.propTypes = {
    className: PropTypes.string,
};
